import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'; // <-- agregado HttpParams
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './login.service';
import config from '../../app/config.json';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private apiUrl = config.Api.Apiurl;
  private usuariosUrl = `${this.apiUrl}/administracion/usuario`;
  private codigosUrl = `${this.apiUrl}/parametros/codigo`;
  private reporteTipoUrl = `${this.apiUrl}/administracion/reporte`;
  private supervisorUrl = `${this.apiUrl}/administracion/supervisor`;
  private usuarioAsAdminUrl = `${this.apiUrl}/administracion/usuarioAsAdmin`; // Nueva URL
  private sujetoRutUrl = `${this.apiUrl}/analisis/sujetoRUT`; // Nueva URL
  private usuarioUrlEstado = `${this.apiUrl}/administracion/usuarioEstado`; // Nueva URL

  // Endpoints exportación usuarios
  private consultasUsuarioXLSXUrl = `${this.apiUrl}/administracion/consultas/usuarioXLSX`;
  private consultasUsuarioPDFUrl  = `${this.apiUrl}/administracion/consultas/usuarioPDF`;

  constructor(private http: HttpClient, private loginService: LoginService) { }

  getUsuarios(): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(this.usuariosUrl, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener los usuarios:', error);
        return throwError(() => error);
      })
    );
  }
  delUsuario(id: number): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.delete<any>(`${this.usuariosUrl}/${id}`, { headers });
  }

  getUsuarioById(id: number): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(`${this.usuariosUrl}/${id}`, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener el usuario:', error);
        return throwError(() => error);
      })
    );
  }

  updateSujeto(id: number, data: any): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');

    return this.http.put<any>(`${this.usuariosUrl}/${id}`, data, { headers }).pipe(
      catchError((error) => {
        console.error('Error al actualizar el usuario:', error);
        return throwError(() => error);
      })
    );
  }

  addUsuario(usuario: any): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');

    return this.http.post<any>(this.usuariosUrl, usuario, { headers }).pipe(
      catchError(this.handleError)
    );
  }

  addUsuarioAsAdmin(usuario: any): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');

    return this.http.post<any>(this.usuarioAsAdminUrl, usuario, { headers })
  }

  getCodigos(): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(this.codigosUrl, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener los codigos:', error);
        return throwError(() => error);
      })
    );
  }
  uploadProfileImage(imageData: any, id: number) {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(`${this.apiUrl}/administracion/usuario/perfil/${id}`, imageData, {headers});
  }

  getProfileImage(id: number) {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(`${this.apiUrl}/administracion/usuario/perfil/${id}`, {headers});
  }

  getReporteTipo(): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(this.reporteTipoUrl, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener los codigos:', error);
        return throwError(() => error);
      })
    );
  }

  isSupervisor(): Observable<boolean> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);
    return this.http.get<boolean>(this.supervisorUrl, { headers }).pipe(
      catchError((error) => {
        console.error('Error al verificar si es supervisor:', error);
        return throwError(() => error);
      })
    );
  }

  updateUsuario(id: number, data: any): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }
    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json');

    return this.http.put<any>(`${this.usuariosUrl}/${id}`, data, { headers }).pipe(
      catchError((error) => {
        console.error('Error al actualizar el usuario:', error);
        return throwError(() => error);
      })
    );
  }

  getSujetoByRut(rut: string): Observable<number> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(`${this.sujetoRutUrl}?rut=${rut}`, { headers }).pipe(
      map(response => response.id_sujeto),
      catchError((error) => {
        console.error('Error al obtener el sujeto por RUT:', error);
        return throwError(() => error);
      })
    );
  }
  updateUsuarioEstado(): Observable<any> {
    //console.log('Actualizando estado del usuario');
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    return this.http.post<any>(this.usuarioUrlEstado, {}, { headers }).pipe(
      catchError((error) => {
        console.error('Error al actualizar el estado del usuario:', error);
        return throwError(() => error);
      })
    );
  }

  getConsultasUsuario(
    usuarios: number[] | string,
    moneda: string,
    fecha_inicio: string,
    fecha_fin: string
  ): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    // Si usuarios es string, conviértelo a array de números
    let usuariosArr: number[] = [];
    if (Array.isArray(usuarios)) {
      usuariosArr = usuarios as number[];
    } else if (typeof usuarios === 'string') {
      usuariosArr = usuarios.split(',').map((id: string) => Number(id));
    }

    // Construye los params tipo usuarios[]=61&usuarios[]=100
    let params = usuariosArr.map((id: number) => `usuarios[]=${id}`).join('&');
    params += `&moneda=${encodeURIComponent(moneda)}&fecha_inicio=${encodeURIComponent(fecha_inicio)}&fecha_fin=${encodeURIComponent(fecha_fin)}`;

    const url = `${this.apiUrl}/administracion/consultas/usuario?${params}`;

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener las consultas de usuario:', error);
        return throwError(() => error);
      })
    );
  }

  // Descargar XLSX (usuarios=1&usuarios=2...)
  descargarUsuariosXLSX(usuarios: number[], fechaInicio: string, fechaFin: string, moneda?: string): Observable<Blob> {
    const token = this.getTokenFromCache();
    if (!token) return throwError(() => new Error('Token no disponible'));

    const headers = new HttpHeaders()
      .set('accept', 'application/vnd.ms-excel')
      .set('Authorization', `Bearer ${token}`);

    let params = new HttpParams()
      .set('fecha_inicio', fechaInicio)
      .set('fecha_fin', fechaFin);

    if (moneda && moneda !== 'NONE') {
      params = params.set('moneda', moneda.toLowerCase().trim());
    }

    usuarios.forEach(id => {
      params = params.append('usuarios', id.toString());
    });

    return this.http.get(this.consultasUsuarioXLSXUrl, {
      headers,
      params,
      responseType: 'blob'
    }).pipe(
      catchError(err => {
        console.error('Error al descargar XLSX de usuarios:', err);
        return throwError(() => err);
      })
    );
  }

  // Descargar PDF (usuarios=1&usuarios=2...)
  descargarUsuariosPDF(usuarios: number[], fechaInicio: string, fechaFin: string, moneda?: string): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders({
      'accept': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    let params = new HttpParams()
      .set('fecha_inicio', fechaInicio)
      .set('fecha_fin', fechaFin);

    if (moneda && moneda !== 'NONE') {
      params = params.set('moneda', moneda.toLowerCase().trim());
    }

    usuarios.forEach(id => {
      params = params.append('usuarios', id.toString());
    });

    return this.http.get<any>(this.consultasUsuarioPDFUrl, {
      headers,
      params
    }).pipe(
      catchError(error => {
        if (error.status === 403) {
          alert('Estimado Usuario, no le quedan reportes restantes, por favor comuníquese con el administrador');
        }
        console.error('Error al obtener PDF:', error);
        return throwError(() => error);
      })
    );
  }

  getBitacoraUsuario(): Observable<any> {
    const token = this.getTokenFromCache();
    if (!token) {
      console.error('Token no disponible');
      return throwError(() => new Error('Token no disponible'));
    }

    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    return this.http.get<any>(`${this.apiUrl}/administracion/bitacora/usuario`, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener la bitácora de usuario:', error);
        return throwError(() => error);
      })
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('Ocurrió un error:', error);
    return throwError(() => new Error('Ocurrió un error; por favor, inténtelo de nuevo más tarde.'));
  }

  private getTokenFromCache(): string | null {
    return this.loginService.getToken();
  }
}
